import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import {
  People as PeopleIcon,
  EventNote as EventNoteIcon,
  Work as WorkIcon,
  AttachMoney as AttachMoneyIcon,
  Assignment as AssignmentIcon,
  MeetingRoom as MeetingRoomIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
} from '@mui/icons-material';
import { PieChart, Pie, Cell, LineChart, Line, XAxis, YAxis, CartesianGrid, BarChart, Bar } from 'recharts';
import useCompanySettings from '../hooks/useCompanySettings'; // Merkezi şirket ayarlarını almak için hook
import DeviceStatusCard from '../components/DeviceStatusCard';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import api from '../api/api';

function Dashboard() {
  const [employeeCount, setEmployeeCount] = useState(0);
  const [leaveCount, setLeaveCount] = useState(0);
  const [projectCount, setProjectCount] = useState(0);
  const [departmentCount, setDepartmentCount] = useState(0);
  const [salaryAverage, setSalaryAverage] = useState(0);
  const [activeProjectCount, setActiveProjectCount] = useState(0);
  const [meetingRoomCount, setMeetingRoomCount] = useState(0);
  const [payrollCount, setPayrollCount] = useState(0);
  const [departmentData, setDepartmentData] = useState([]);
  const [hireDateData, setHireDateData] = useState([]);
  const [salaryData, setSalaryData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [workingHoursData, setWorkingHoursData] = useState([]);
  const [selectedStat, setSelectedStat] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [leaveData, setLeaveData] = useState([]); // Add the leaveData state
  const [projectData, setProjectData] = useState([]);
  const [meetingRoomData, setMeetingRoomData] = useState([]);
  const [payrollData, setPayrollData] = useState([]);
  const [selectedJsonData, setSelectedJsonData] = useState(null);
  const [openJsonTableDialog, setOpenJsonTableDialog] = useState(false);
  const [activeTodayCount, setActiveTodayCount] = useState(0);
  const [exitTodayCount, setExitTodayCount] = useState(0);
  const [employeeList, setEmployeeList] = useState([]);
  const [visitors, setVisitors] = useState([]); // Add the visitors state

  // --- GELİŞMİŞ PERSONEL TAKİP STATE'LERİ ---
  const [insideCount, setInsideCount] = useState(0); // Şu anda içeride olanlar
  const [recentMovements, setRecentMovements] = useState([]); // Son 5 hareket
  const [lateCount, setLateCount] = useState(0); // Gecikenler
  const [earlyExitCount, setEarlyExitCount] = useState(0); // Erken çıkanlar
  const [absentCount, setAbsentCount] = useState(0); // Bugün gelmeyenler
  const [absentees, setAbsentees] = useState([]); // Bugün gelmeyenlerin listesi
  const [longAbsenceCount, setLongAbsenceCount] = useState(0); // Son X gün hiç gelmeyenler
  const [longAbsentees, setLongAbsentees] = useState([]); // Son X gün hiç gelmeyenlerin listesi
  const [overtimeCount, setOvertimeCount] = useState(0); // Fazla mesai yapanlar
  const [overtimers, setOvertimers] = useState([]); // Fazla mesai yapanların listesi
  const [lateArrivals, setLateArrivals] = useState([]); // Gecikenlerin listesi
  const [earlyExits, setEarlyExits] = useState([]); // Erken çıkanların listesi
  const [weeklyStats, setWeeklyStats] = useState([]); // Haftalık giriş-çıkış istatistikleri
  const [monthlyStats, setMonthlyStats] = useState([]); // Aylık giriş-çıkış istatistikleri
  // Parametreler
  const workStartHour = 9; // 09:00'dan sonra gelen gecikmiş sayılır
  const workEndHour = 18; // 18:00'dan önce çıkış yapan erken çıkmış sayılır
  const dailyHourLimit = 8; // 8 saatten fazla çalışan fazla mesai
  const absenceCheckDays = 7; // Son 7 gün devamsızlık için
  // Yeni gelişmiş state'ler
  const [topLateArrivals, setTopLateArrivals] = useState([]); // Haftalık en çok geç kalanlar
  const [topOvertimers, setTopOvertimers] = useState([]); // Haftalık en çok fazla mesai yapanlar
  const [topAbsentees, setTopAbsentees] = useState([]); // Son 30 gün en çok devamsız
  const [avgEntryExit, setAvgEntryExit] = useState({}); // Ortalama giriş/çıkış saatleri
  const [todayOnDuty, setTodayOnDuty] = useState([]); // Bugün görevli olanlar
  const [upcomingBirthdays, setUpcomingBirthdays] = useState([]); // Yaklaşan doğum günleri
  const [seniorEmployees, setSeniorEmployees] = useState([]); // 5 yıl+ çalışanlar

  // Merkezi şirket ayarlarını almak için hook
  const settings = useCompanySettings();

  useEffect(() => {
    const fetchEmployees = () => {
      api.get('/employees')
        .then((response) => {
          const data = response.data;
          
          // Check if response.data has employees property
          const employeesArray = data.employees || data;
          
          // Validate that employeesArray is an array
          if (!Array.isArray(employeesArray)) {
            console.error('API returned non-array data:', data);
            setEmployeeCount(0);
            setDepartmentCount(0);
            setDepartmentData([]);
            setEmployeeData([]);
            setSalaryData([]);
            setHireDateData([]);
            setSalaryAverage(0);
            return;
          }
          
          setEmployeeCount(employeesArray.length);
          // Departmanları büyük/küçük harf uyumlu al
          const departments = new Set(employeesArray.map((employee) => employee.Department || employee.department));
          setDepartmentCount(departments.size);
          const deptData = Array.from(departments).map((dept) => ({
            name: dept,
            value: employeesArray.filter((emp) => (emp.Department || emp.department) === dept).length
          }));
          setDepartmentData(deptData);
          setEmployeeData(employeesArray);
          // Maaş dağılımı için düzeltme
          const salData = employeesArray.map((emp) => {
            let salary = emp.salary || emp.base_salary || emp.BaseSalary || 0;
            salary = isNaN(Number(salary)) ? 0 : Number(salary);
            return { salary };
          });
          setSalaryData(salData);
          // İşe giriş yılı dağılımı için düzeltme
          const hireYearMap = {};
          employeesArray.forEach((emp) => {
            let rawDate = emp.HireDate || emp.hireDate;
            let year = 'Bilinmiyor';
            if (rawDate && typeof rawDate === 'string') {
              const dateObj = new Date(rawDate);
              if (!isNaN(dateObj.getTime())) {
                year = String(dateObj.getFullYear());
              }
            }
            if (!hireYearMap[year]) hireYearMap[year] = 0;
            hireYearMap[year] += 1;
          });
          const hireData = Object.keys(hireYearMap).map((year) => ({
            hireDate: year,
            value: hireYearMap[year],
          }));
          setHireDateData(hireData);
          // Ortalama maaş
          const totalSalary = employeesArray.reduce((sum, employee) => sum + Number(employee.salary || employee.base_salary || employee.BaseSalary || 0), 0);
          setSalaryAverage(employeesArray.length > 0 ? totalSalary / employeesArray.length : 0);
        })
        .catch((error) => {
          console.error('Çalışan verileri alınırken hata oluştu:', error);
          // Reset states on error
          setEmployeeCount(0);
          setDepartmentCount(0);
          setDepartmentData([]);
          setEmployeeData([]);
          setSalaryData([]);
          setHireDateData([]);
          setSalaryAverage(0);
        });
    };

    const fetchLeaves = () => {
      api.get('/leave-requests')
        .then((response) => {
          const data = response.data;
          // Validate that data is an array
          if (!Array.isArray(data)) {
            console.error('Leave API returned non-array data:', data);
            setLeaveCount(0);
            setLeaveData([]);
            return;
          }
          // SADECE BUGÜNÜN VE ONAYLANMIŞ İZİNLERİ
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          // Bugün başlayan veya devam eden ve onaylanmış izinler
          const approvedLeaves = data.filter((item) => {
            const start = new Date(item.StartDate);
            const end = new Date(item.EndDate);
            const isApproved = (item.Status || item.status || item.LeaveRequestStatus) === 'Approved';
            return (start <= tomorrow && end >= today) && isApproved;
          });
          setLeaveCount(approvedLeaves.length);
          setLeaveData(approvedLeaves);
        })
        .catch((error) => {
          console.error('İzin verileri alınırken hata oluştu:', error);
          setLeaveCount(0);
          setLeaveData([]);
        });
    };

    const fetchProjects = () => {
      api.get('/projects')
        .then((response) => {
          const data = response.data;
          // Validate that data is an array
          if (!Array.isArray(data)) {
            console.error('Projects API returned non-array data:', data);
            setProjectCount(0);
            setActiveProjectCount(0);
            setProjectData([]);
            return;
          }
          setProjectCount(data.length);
          const activeProjects = data.filter((project) => project.status === 'Active');
          setActiveProjectCount(activeProjects.length);
          setProjectData(data);
        })
        .catch((error) => {
          console.error('Proje verileri alınırken hata oluştu:', error);
          setProjectCount(0);
          setActiveProjectCount(0);
          setProjectData([]);
        });
    };

    const fetchMeetingRooms = () => {
      api.get('/meeting-rooms')
        .then((response) => {
          const data = response.data;
          // Validate that data is an array
          if (!Array.isArray(data)) {
            console.error('Meeting rooms API returned non-array data:', data);
            setMeetingRoomCount(0);
            setMeetingRoomData([]);
            return;
          }
          setMeetingRoomCount(data.length);
          setMeetingRoomData(data);
        })
        .catch((error) => {
          console.error('Toplantı odası verileri alınırken hata oluştu:', error);
          setMeetingRoomCount(0);
          setMeetingRoomData([]);
        });
    };

    const fetchPayrolls = () => {
      api.get('/payrolls')
        .then((response) => {
          const data = response.data;
          // Validate that data is an array
          if (!Array.isArray(data)) {
            console.error('Payrolls API returned non-array data:', data);
            setPayrollCount(0);
            setPayrollData([]);
            return;
          }
          setPayrollCount(data.length);
          setPayrollData(data);
        })
        .catch((error) => {
          console.error('Bordro verileri alınırken hata oluştu:', error);
          setPayrollCount(0);
          setPayrollData([]);
        });
    };

    const fetchAttendance = () => {
      api.get('/attendance')
        .then((response) => {
          const data = response.data;
          // Validate that data has attendance property and it's an array
          if (!data || !data.attendance || !Array.isArray(data.attendance)) {
            console.error('Attendance API returned invalid data:', data);
            setAttendanceData([]);
            setActiveTodayCount(0);
            setExitTodayCount(0);
            return;
          }
          // SADECE BUGÜNÜN KAYITLARI
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Bugünün 00:00:00
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          // Tarih filtrelemesi
          const todaysAttendance = data.attendance.filter((item) => {
            const entryDate = new Date(item.EntryTime);
            return entryDate >= today && entryDate < tomorrow;
          });
          const attendanceMap = new Map();
          todaysAttendance.forEach((item) => {
            if (!attendanceMap.has(item.EmployeeID) || new Date(item.EntryTime) > new Date(attendanceMap.get(item.EmployeeID).EntryTime)) {
              attendanceMap.set(item.EmployeeID, item);
            }
          });

          // Bugün çıkış yapan personel sayısı
          const exitToday = todaysAttendance.filter((item) => {
            if (!item.ExitTime) return false;
            const exitDate = new Date(item.ExitTime);
            return exitDate >= today && exitDate < tomorrow;
          });
          setExitTodayCount(exitToday.length);

          // Ad soyad ekle (FirstName, LastName API'den)
          const formattedAttendanceData = Array.from(attendanceMap.values()).map((item) => ({
            employeeName: item.EmployeeID,
            fullName: `${item.FirstName || ''} ${item.LastName || ''}`.trim(),
            entryTime: item.EntryTime,
            exitTime: item.ExitTime,
            totalHours: calculateTotalHoursUTC(item.EntryTime, item.ExitTime),
            EmployeeID: item.EmployeeID,
            EntryTime: item.EntryTime,
            ExitTime: item.ExitTime,
            FirstName: item.FirstName,
            LastName: item.LastName,
          }));
          setAttendanceData(formattedAttendanceData);
          setActiveTodayCount(attendanceMap.size); // Aktif bugün giriş yapan personel sayısı

          // --- GELİŞMİŞ PERSONEL TAKİP HESAPLAMALARI ---
          const fetchAllAdvancedStats = (data, employeeData, leaveData) => {
            // Günlük ve haftalık veriler için tarihleri hazırla
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            // Bugünün kayıtları
            const todaysAttendance = data.attendance.filter((item) => {
              const entryDate = new Date(item.EntryTime);
              return entryDate >= today && entryDate < tomorrow;
            });
            // Şu anda içeride olanlar (giriş yapmış, çıkış yapmamış)
            const inside = todaysAttendance.filter((item) => !item.ExitTime);
            setInsideCount(inside.length);
            // Son 5 hareket (giriş/çıkış)
            const movements = [...todaysAttendance]
              .sort((a, b) => new Date(b.EntryTime) - new Date(a.EntryTime))
              .slice(0, 5)
              .map((item) => ({
                fullName: `${item.FirstName || ''} ${item.LastName || ''}`.trim(),
                entryTime: item.EntryTime,
                exitTime: item.ExitTime,
                EmployeeID: item.EmployeeID,
              }));
            setRecentMovements(movements);
            // Gecikenler
            const late = todaysAttendance.filter((item) => {
              const entry = new Date(item.EntryTime);
              return entry.getHours() > workStartHour || (entry.getHours() === workStartHour && entry.getMinutes() > 0);
            });
            setLateCount(late.length);
            setLateArrivals(late.map(item => ({
              fullName: `${item.FirstName || ''} ${item.LastName || ''}`.trim(),
              entryTime: item.EntryTime,
              EmployeeID: item.EmployeeID,
            })));
            // Erken çıkanlar
            const early = todaysAttendance.filter((item) => {
              if (!item.ExitTime) return false;
              const exit = new Date(item.ExitTime);
              return exit.getHours() < workEndHour;
            });
            setEarlyExitCount(early.length);
            setEarlyExits(early.map(item => ({
              fullName: `${item.FirstName || ''} ${item.LastName || ''}`.trim(),
              exitTime: item.ExitTime,
              EmployeeID: item.EmployeeID,
            })));
            // Fazla mesai yapanlar
            const over = todaysAttendance.filter((item) => {
              if (!item.EntryTime || !item.ExitTime) return false;
              const entry = new Date(item.EntryTime);
              const exit = new Date(item.ExitTime);
              const total = (exit - entry) / (1000 * 60 * 60);
              return total > dailyHourLimit;
            });
            setOvertimeCount(over.length);
            setOvertimers(over.map(item => ({
              fullName: `${item.FirstName || ''} ${item.LastName || ''}`.trim(),
              entryTime: item.EntryTime,
              exitTime: item.ExitTime,
              EmployeeID: item.EmployeeID,
            })));
            // Bugün hiç gelmeyenler
            const absentList = employeeData.filter(emp => !todaysAttendance.some(att => att.EmployeeID === emp.EmployeeID));
            setAbsentCount(absentList.length);
            setAbsentees(absentList.map(emp => ({
              fullName: `${emp.FirstName || ''} ${emp.LastName || ''}`.trim(),
              department: emp.Department || '',
              EmployeeID: emp.EmployeeID,
            })));
            // Son 7 gün devamsızlar
            const startCheck = new Date(today);
            startCheck.setDate(today.getDate() - absenceCheckDays);
            const attendanceLastWeek = data.attendance.filter(item => {
              const entry = new Date(item.EntryTime);
              return entry >= startCheck && entry < tomorrow;
            });
            const presentIDs = new Set(attendanceLastWeek.map(item => item.EmployeeID));
            const longAbsList = employeeData.filter(emp => !presentIDs.has(emp.EmployeeID));
            setLongAbsenceCount(longAbsList.length);
            setLongAbsentees(longAbsList.map(emp => ({
              fullName: `${emp.FirstName || ''} ${emp.LastName || ''}`.trim(),
              department: emp.Department || '',
              EmployeeID: emp.EmployeeID,
            })));
            // Haftalık/Aylık giriş-çıkış istatistikleri
            const weekStats = [];
            for (let i = 6; i >= 0; i--) {
              const day = new Date(today);
              day.setDate(today.getDate() - i);
              const dayStr = `${day.getDate().toString().padStart(2, '0')}-${(day.getMonth()+1).toString().padStart(2, '0')}`;
              const count = data.attendance.filter(item => {
                const entry = new Date(item.EntryTime);
                return entry.getDate() === day.getDate() && entry.getMonth() === day.getMonth() && entry.getFullYear() === day.getFullYear();
              }).length;
              weekStats.push({ day: dayStr, count });
            }
            setWeeklyStats(weekStats);
            // Aylık
            const monthStats = [];
            const thisMonth = today.getMonth();
            for (let d = 1; d <= 31; d++) {
              const count = data.attendance.filter(item => {
                const entry = new Date(item.EntryTime);
                return entry.getDate() === d && entry.getMonth() === thisMonth && entry.getFullYear() === today.getFullYear();
              }).length;
              monthStats.push({ day: d, count });
            }
            setMonthlyStats(monthStats);
            // Haftalık en çok geç kalanlar
            const weekAgo = new Date(today);
            weekAgo.setDate(today.getDate() - 6);
            const weeklyAttendance = data.attendance.filter(item => {
              const entry = new Date(item.EntryTime);
              return entry >= weekAgo && entry < tomorrow;
            });
            const lateMap = {};
            weeklyAttendance.forEach(item => {
              const entry = new Date(item.EntryTime);
              if (entry.getHours() > workStartHour || (entry.getHours() === workStartHour && entry.getMinutes() > 0)) {
                const key = item.EmployeeID;
                if (!lateMap[key]) lateMap[key] = { count: 0, fullName: `${item.FirstName || ''} ${item.LastName || ''}`.trim(), EmployeeID: item.EmployeeID };
                lateMap[key].count += 1;
              }
            });
            const lateArr = Object.values(lateMap).sort((a, b) => b.count - a.count).slice(0, 5);
            setTopLateArrivals(lateArr);
            // Haftalık en çok fazla mesai yapanlar
            const overtimeMap = {};
            weeklyAttendance.forEach(item => {
              if (!item.EntryTime || !item.ExitTime) return;
              const entry = new Date(item.EntryTime);
              const exit = new Date(item.ExitTime);
              const total = (exit - entry) / (1000 * 60 * 60);
              if (total > dailyHourLimit) {
                const key = item.EmployeeID;
                if (!overtimeMap[key]) overtimeMap[key] = { total: 0, fullName: `${item.FirstName || ''} ${item.LastName || ''}`.trim(), EmployeeID: item.EmployeeID };
                overtimeMap[key].total += (total - dailyHourLimit);
              }
            });
            const overArr = Object.values(overtimeMap).sort((a, b) => b.total - a.total).slice(0, 5);
            setTopOvertimers(overArr);
            // Son 30 gün en çok devamsız
            const monthAgo = new Date(today);
            monthAgo.setDate(today.getDate() - 29);
            const monthAttendance = data.attendance.filter(item => {
              const entry = new Date(item.EntryTime);
              return entry >= monthAgo && entry < tomorrow;
            });
            const allEmpIDs = employeeData.map(emp => emp.EmployeeID);
            const presentByDay = {};
            for (let i = 0; i < 30; i++) {
              const day = new Date(today);
              day.setDate(today.getDate() - i);
              const dayStr = `${day.getFullYear()}-${(day.getMonth()+1).toString().padStart(2, '0')}-${day.getDate().toString().padStart(2, '0')}`;
              presentByDay[dayStr] = new Set(monthAttendance.filter(item => {
                const entry = new Date(item.EntryTime);
                return entry.getFullYear() === day.getFullYear() && entry.getMonth() === day.getMonth() && entry.getDate() === day.getDate();
              }).map(item => item.EmployeeID));
            }
            const absenteeMap = {};
            allEmpIDs.forEach(id => {
              let abs = 0;
              Object.values(presentByDay).forEach(daySet => { if (!daySet.has(id)) abs += 1; });
              if (abs > 0) absenteeMap[id] = abs;
            });
            const absenteeArr = Object.entries(absenteeMap).map(([id, count]) => {
              const emp = employeeData.find(e => String(e.EmployeeID) === String(id));
              return { fullName: `${emp?.FirstName || ''} ${emp?.LastName || ''}`.trim(), count, EmployeeID: id };
            }).sort((a, b) => b.count - a.count).slice(0, 5);
            setTopAbsentees(absenteeArr);
            // Ortalama giriş/çıkış saatleri (haftalık)
            const entryTimes = [], exitTimes = [];
            weeklyAttendance.forEach(item => {
              if (item.EntryTime) entryTimes.push(new Date(item.EntryTime));
              if (item.ExitTime) exitTimes.push(new Date(item.ExitTime));
            });
            const avgEntry = entryTimes.length ? new Date(entryTimes.reduce((sum, d) => sum + d.getTime(), 0) / entryTimes.length) : null;
            const avgExit = exitTimes.length ? new Date(exitTimes.reduce((sum, d) => sum + d.getTime(), 0) / exitTimes.length) : null;
            setAvgEntryExit({
              entry: avgEntry ? `${avgEntry.getHours().toString().padStart(2, '0')}:${avgEntry.getMinutes().toString().padStart(2, '0')}` : '-',
              exit: avgExit ? `${avgExit.getHours().toString().padStart(2, '0')}:${avgExit.getMinutes().toString().padStart(2, '0')}` : '-',
            });
            // Bugün görevli olanlar (LeaveType: 'Görevli')
            const dutyList = leaveData.filter(item => {
              const start = new Date(item.StartDate);
              const end = new Date(item.EndDate);
              return (item.LeaveType === 'Görevli' && start <= tomorrow && end >= today);
            });
            setTodayOnDuty(dutyList.map(item => ({
              fullName: `${item.FirstName || ''} ${item.LastName || ''}`.trim(),
              start: item.StartDate,
              end: item.EndDate
            })));
            // Yaklaşan doğum günleri (önümüzdeki 7 gün)
            const now = new Date();
            const upcoming = employeeData.filter(emp => {
              if (!emp.BirthDate) return false;
              const birth = new Date(emp.BirthDate);
              birth.setFullYear(now.getFullYear());
              const diff = (birth - now) / (1000 * 60 * 60 * 24);
              return diff >= 0 && diff <= 7;
            });
            setUpcomingBirthdays(upcoming.map(emp => ({
              fullName: `${emp.FirstName || ''} ${emp.LastName || ''}`.trim(),
              date: emp.BirthDate
            })));
            // Kıdemli personeller (5 yıl+)
            const seniorList = employeeData.filter(emp => {
              if (!emp.HireDate) return false;
              const hire = new Date(emp.HireDate);
              const years = (Date.now() - hire.getTime()) / (1000 * 60 * 60 * 24 * 365.25);
              return years >= 5;
            });
            setSeniorEmployees(seniorList.map(emp => ({
              fullName: `${emp.FirstName || ''} ${emp.LastName || ''}`.trim(),
              hireDate: emp.HireDate
            })));
          };
          fetchAllAdvancedStats(data, employeeData, leaveData);
        })
        .catch((error) => {
          console.error('Giriş-çıkış verileri alınırken hata oluştu:', error);
          setAttendanceData([]);
          setActiveTodayCount(0);
          setExitTodayCount(0);
        });
    };

    const fetchVisitors = () => {
      api.get('/visitors')
        .then(response => {
          const data = response.data;
          // Validate that data is an array
          if (!Array.isArray(data)) {
            console.error('Visitors API returned non-array data:', data);
            setVisitors([]);
            return;
          }
          setVisitors(data);
        })
        .catch(err => {
          console.error('Error fetching visitors:', err);
          setVisitors([]);
        });
    };

    fetchEmployees();
    fetchLeaves();
    fetchProjects();
    fetchMeetingRooms();
    fetchPayrolls();
    fetchAttendance();
    fetchVisitors();

    const intervalId = setInterval(() => {
      fetchEmployees();
      fetchLeaves();
      fetchProjects();
      fetchMeetingRooms();
      fetchPayrolls();
      fetchAttendance();
      fetchVisitors();
    }, 60 * 1000); // 1 dakika

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const dailyHourLimit = 8;
    // SADECE BUGÜNÜN ÇALIŞMA SÜRELERİ
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const filtered = attendanceData.filter((row) => {
      // entryTime formatı: MM-DD-YYYY HH:mm:ss
      if (!row.entryTime || row.entryTime === 'Bilinmiyor') return false;
      const [datePart] = row.entryTime.split(' ');
      const [month, day, year] = datePart.split('-');
      const entryDate = new Date(`${year}-${month}-${day}`);
      return entryDate >= today && entryDate < tomorrow;
    });
    const result = filtered.map((row) => {
      const total = parseFloat(row.totalHours);
      const overtime = total > dailyHourLimit ? (total - dailyHourLimit) : 0;
      return {
        ID: row.ID,
        fullName: `${row.FirstName} ${row.LastName}`,
        totalHours: total.toFixed(2),
        overtimeHours: overtime.toFixed(2),
      };
    });
    setWorkingHoursData(result);
  }, [attendanceData]);

  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const todaysAttendanceIDs = new Set(attendanceData.filter(row => {
      if (!row.EntryTime && !row.entryTime) return false;
      const entry = new Date(row.EntryTime || row.entryTime);
      return entry >= today && entry < tomorrow;
    }).map(row => row.EmployeeID));

    const absenteesSafe = employeeData.filter(emp => emp.EmployeeID && !todaysAttendanceIDs.has(emp.EmployeeID));

    const workStart = settings?.workStart || '09:00';
    const [startHour, startMinute] = workStart.split(':').map(Number);
    const lateArrivalsSafe = attendanceData.filter(row => {
      if (!row.EntryTime && !row.entryTime) return false;
      const entry = new Date(row.EntryTime || row.entryTime);
      return entry >= today && entry < tomorrow &&
        (entry.getHours() > startHour || (entry.getHours() === startHour && entry.getMinutes() > startMinute));
    });

    setAbsentees(absenteesSafe);
    setLateArrivals(lateArrivalsSafe);
  }, [attendanceData, employeeData, settings]);

  useEffect(() => {
    api.get('/employees')
      .then(response => {
        const data = response.data;
        
        // Check if response.data has employees property
        const employeesArray = data.employees || data;
        
        // Validate that employeesArray is an array
        if (!Array.isArray(employeesArray)) {
          console.error('Employee list API returned non-array data:', data);
          setEmployeeList([]);
          return;
        }
        setEmployeeList(employeesArray);
      })
      .catch(error => {
        console.error('Error fetching employee list:', error);
        setEmployeeList([]);
      });
  }, []);

  const enrichWithEmployeeData = (arr) => {
    // Validate that arr is an array
    if (!Array.isArray(arr)) {
      console.error('enrichWithEmployeeData called with non-array data:', arr);
      return [];
    }
    return arr.map(row => {
      const employee = employeeList.find(e => String(e.EmployeeID) === String(row.EmployeeID));
      return {
        ...row,
        fullName: employee ? `${employee.FirstName || employee.firstname || ''} ${employee.LastName || employee.lastname || ''}`.trim() : '',
        department: employee ? (employee.Department || employee.department || '') : '',
      };
    });
  };

  const attendanceDataEnriched = enrichWithEmployeeData(attendanceData);
  const recentMovementsEnriched = enrichWithEmployeeData(recentMovements);
  const lateArrivalsEnriched = enrichWithEmployeeData(lateArrivals);
  const earlyExitsEnriched = enrichWithEmployeeData(earlyExits);
  const absenteesEnriched = enrichWithEmployeeData(absentees);
  const longAbsenteesEnriched = enrichWithEmployeeData(longAbsentees);
  const overtimersEnriched = enrichWithEmployeeData(overtimers);

  const formatDate = (dateString) => {
    if (!dateString) {
      return 'Bilinmiyor';
    }
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const calculateTotalHours = (entryTime, exitTime) => {
    if (!entryTime || !exitTime) {
      return 'Bilinmiyor';
    }
    const entry = new Date(entryTime);
    const exit = new Date(exitTime);
    const totalMilliseconds = exit - entry;
    const totalHours = totalMilliseconds / (1000 * 60 * 60);
    return totalHours.toFixed(2);
  };

  // UTC (+0) zaman dilimine göre saat farkı ile doğru hesaplama
  const calculateTotalHoursUTC = (entryTime, exitTime) => {
    if (!entryTime || !exitTime) {
      return 'Bilinmiyor';
    }
    const entry = new Date(new Date(entryTime).toLocaleString('en-US', { timeZone: 'UTC' }));
    const exit = new Date(new Date(exitTime).toLocaleString('en-US', { timeZone: 'UTC' }));
    const totalMilliseconds = exit - entry;
    const totalHours = totalMilliseconds / (1000 * 60 * 60);
    return totalHours.toFixed(2);
  };

  // HireDate ve saat alanlarını doğru göstermek için saat farkı kontrolü
  const formatHireDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleString('tr-TR', {
      timeZone: 'UTC',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', '');
  };

  // UTC (+0) zaman dilimine göre tarihi Türkçe ve dd-MM-yyyy hh:mm formatında göster
  const formatUTCDateTR = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleString('tr-TR', {
      timeZone: 'UTC',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', '');
  };

  // İzinli çalışan popup'ında tarihleri dd-MM-yyyy hh:mm olarak göster
  const formatLeaveDateTR = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${year} ${hour}:${minute}`;
  };

  const stats = [
    {
      title: 'Toplam Çalışan',
      value: employeeCount,
      icon: <PeopleIcon sx={{ fontSize: 40 }} />, 
      color: '#1976d2',
      details: `Toplam çalışan sayısı: ${employeeCount}`,
    },
    {
      title: 'İzinli Çalışan',
      value: leaveCount,
      icon: <EventNoteIcon sx={{ fontSize: 40 }} />, 
      color: '#ed6c02',
      details: `Toplam izinli çalışan sayısı: ${leaveCount}`,
    },
    {
      title: 'Ortalama Maaş',
      value: `${salaryAverage.toFixed(2)} ${settings?.currency || '₺'}`,
      icon: <AttachMoneyIcon sx={{ fontSize: 40, color: '#fff' }} />, // Beyaz para simgesi
      color: '#3f51b5',
      details: `Ortalama maaş: ${salaryAverage.toFixed(2)} ${settings?.currency || '₺'}`,
    },
    {
      title: 'Ziyaretçi Sayısı',
      value: visitors.length,
      icon: <PeopleIcon sx={{ fontSize: 40 }} />, 
      color: '#ff9800',
      details: `Toplam ziyaretçi sayısı: ${visitors.length}`,
    },
    {
      title: 'Toplantı Odaları',
      value: meetingRoomCount,
      icon: <MeetingRoomIcon sx={{ fontSize: 40 }} />, 
      color: '#00bcd4',
      details: `Toplam toplantı odası sayısı: ${meetingRoomCount}`,
    },
    {
      title: 'Departmanlar',
      value: departmentCount,
      icon: <WorkIcon sx={{ fontSize: 40, color: '#fff' }} />, // Beyaz renk
      color: '#9c27b0',
      details: `Toplam departman sayısı: ${departmentCount}`,
    },
    {
      title: 'Bugün Çıkış Yapan',
      value: exitTodayCount,
      icon: <PeopleIcon sx={{ fontSize: 40, color: '#fff' }} />, // Beyaz renk
      color: '#ff5722',
      details: `Bugün çıkış yapan personel sayısı: ${exitTodayCount}`,
    },
    {
      title: 'Aktif (Bugün Giriş Yapan)',
      value: activeTodayCount,
      icon: <PeopleIcon sx={{ fontSize: 40 }} color="success" />, 
      color: '#43a047',
      details: `Bugün giriş yapan personel sayısı: ${activeTodayCount}`,
    },
  ];

  const pieColors = ['#1976d2', '#ed6c02', '#3f51b5', '#9c27b0', '#4caf50', '#ff9800', '#00bcd4', '#ff5722'];

  const handleCardClick = (stat) => {
    setSelectedStat(stat);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleStatCardClick = (data) => {
    setSelectedJsonData(data);
    setOpenJsonTableDialog(true);
  };

  const handleCloseJsonTableDialog = () => {
    setOpenJsonTableDialog(false);
  };

  const turkishColumnNames = {
    EmployeeID: 'Personel ID',
    fullName: 'Ad Soyad',
    department: 'Departman',
    Department: 'Departman',
    EntryTime: 'Giriş Saati',
    entryTime: 'Giriş Saati',
    ExitTime: 'Çıkış Saati',
    exitTime: 'Çıkış Saati',
    totalHours: 'Toplam Çalışma Süresi',
    overtimeHours: 'Fazla Mesai (saat)',
    StartDate: 'Başlangıç Tarihi',
    EndDate: 'Bitiş Tarihi',
    LeaveType: 'İzin Türü',
    salary: 'Maaş',
    hireDate: 'İşe Alım Yılı',
    HireDate: 'İşe Giriş Tarihi',
    value: 'Değer',
    ID: 'ID',
    date: 'Tarih',
    BaseSalary: 'Maaş',
    FirstName: 'Ad',
    LastName: 'Soyad',
    Email: 'E-posta',
    Phone: 'Telefon',
    Position: 'Pozisyon',
    Status: 'Durum',
    PasswordHash: 'Şifre (Hash)',
    LeaveRequestID: 'İzin Talep No',
    LeaveRequestStatus: 'İzin Durumu',
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <Tooltip title="Bu sayfada genel durumu görebilirsiniz.">
          <InfoOutlinedIcon color="primary" style={{ marginRight: 8, cursor: 'pointer' }} />
        </Tooltip>
        <Typography variant="h6" component="div" gutterBottom>
          {settings?.companyName || 'Şirket Adı'}
        </Typography>
      </div>
      <Grid container spacing={3}>  
        {stats.map((stat) => (
          <Grid item xs={12} sm={6} md={3} key={stat.title}>
            <Paper elevation={3}>
              <Card onClick={() => {
                if (stat.title === 'Toplam Çalışan') {
                  handleStatCardClick(employeeData);
                } else if (stat.title === 'İzinli Çalışan') {
                  handleStatCardClick(leaveData);
                } else if (stat.title === 'Toplam Proje') {
                  handleStatCardClick(projectData);
                } else if (stat.title === 'Toplantı Odaları') {
                  handleStatCardClick(meetingRoomData);
                } else if (stat.title === 'Bordrolar') {
                  handleStatCardClick(payrollData);
                }
              }}>
                <CardContent>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: stat.color,
                        borderRadius: 1,
                        p: 1,
                        color: 'white',
                        mr: 2,
                      }}
                    >
                      {stat.icon}
                    </Box>
                    <Box>
                      <Typography variant="h4" component="div" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {stat.value}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {stat.title}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Paper>
          </Grid>
        ))}
      
        
        {/* --- GELİŞMİŞ PERSONEL TAKİP TABLOLARI --- */}
        
      </Grid>
      {/* --- GELENEKSEL TABLOLAR --- */}
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Card sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <CardContent sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography variant="h6" component="div" gutterBottom>
                  Departman Dağılımı
                </Typography>
                <PieChart width={400} height={300}>
                  <Pie
                    data={departmentData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    fill="#8884d8"
                    label={({ name, value }) => `${name}: ${value}`}
                  >
                    {departmentData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} />
                    ))}
                  </Pie>
                </PieChart>
              </CardContent>
            </Card>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Card sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <CardContent sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography variant="h6" component="div" gutterBottom>
                  İşe Alım Tarihi Dağılımı
                </Typography>
                <LineChart width={400} height={300} data={hireDateData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="hireDate" />
                  <YAxis />
                  <Line type="monotone" dataKey="value" stroke="#8884d8" activeDot={{ r: 8 }} />
                </LineChart>
              </CardContent>
            </Card>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Card sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <CardContent sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography variant="h6" component="div" gutterBottom>
                  Maaş Dağılımı
                </Typography>
                <BarChart width={400} height={300} data={salaryData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="salary" />
                  <YAxis />
                  <Bar dataKey="salary" fill="#8884d8" />
                </BarChart>
              </CardContent>
            </Card>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Card sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <CardContent sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography variant="h6" component="div" gutterBottom>
                  Giriş-Çıkış Tablosu
                </Typography>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Personel ID</TableCell>
                        <TableCell>Ad Soyad</TableCell>
                        <TableCell>Giriş Saati</TableCell>
                        <TableCell>Çıkış Saati</TableCell>
                        <TableCell>Toplam Çalışma Süresi</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {attendanceDataEnriched.length === 0 ? (
                        <TableRow><TableCell colSpan={5} align="center">Veri bulunamadı</TableCell></TableRow>
                      ) : (
                        attendanceDataEnriched.map((row) => (
                          <TableRow key={row.EmployeeID}>
                            <TableCell>{row.EmployeeID}</TableCell>
                            <TableCell>{row.fullName}</TableCell>
                            <TableCell>{formatUTCDateTR(row.entryTime)}</TableCell>
                            <TableCell>{formatUTCDateTR(row.exitTime)}</TableCell>
                            <TableCell>{calculateTotalHoursUTC(row.entryTime, row.exitTime)}</TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Paper>
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={3}>
          {/* Son 5 Giriş/Çıkış Hareketi Tablosu */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Card sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    Son 5 Giriş/Çıkış Hareketi
                  </Typography>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Personel ID</TableCell>
                          <TableCell>Ad Soyad</TableCell>
                          <TableCell>Giriş Saati</TableCell>
                          <TableCell>Çıkış Saati</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {recentMovementsEnriched.length === 0 ? (
                          <TableRow><TableCell colSpan={4} align="center">Veri bulunamadı</TableCell></TableRow>
                        ) : (
                          recentMovementsEnriched.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.EmployeeID || '-'}</TableCell>
                              <TableCell>{row.fullName}</TableCell>
                              <TableCell>{formatUTCDateTR(row.entryTime)}</TableCell>
                              <TableCell>{row.exitTime ? formatUTCDateTR(row.exitTime) : '-'}</TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Paper>
          </Grid>
          {/* Gecikenler Tablosu */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Card sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    Gecikenler
                  </Typography>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Personel ID</TableCell>
                          <TableCell>Ad Soyad</TableCell>
                          <TableCell>Giriş Saati</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {lateArrivalsEnriched.length === 0 ? (
                          <TableRow><TableCell colSpan={3} align="center">Veri bulunamadı</TableCell></TableRow>
                        ) : (
                          lateArrivalsEnriched.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.EmployeeID || '-'}</TableCell>
                              <TableCell>{row.fullName}</TableCell>
                              <TableCell>{formatUTCDateTR(row.entryTime)}</TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Paper>
          </Grid>
          {/* Erken Çıkanlar Tablosu */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Card sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    Erken Çıkanlar
                  </Typography>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Personel ID</TableCell>
                          <TableCell>Ad Soyad</TableCell>
                          <TableCell>Çıkış Saati</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {earlyExitsEnriched.length === 0 ? (
                          <TableRow><TableCell colSpan={3} align="center">Veri bulunamadı</TableCell></TableRow>
                        ) : (
                          earlyExitsEnriched.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.EmployeeID || '-'}</TableCell>
                              <TableCell>{row.fullName}</TableCell>
                              <TableCell>{formatUTCDateTR(row.exitTime)}</TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Paper>
          </Grid>
          {/* Hiç Gelmeyenler Tablosu */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Card sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    Hiç Gelmeyenler
                  </Typography>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Personel ID</TableCell>
                          <TableCell>Ad Soyad</TableCell>
                          <TableCell>Departman</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {absenteesEnriched.length === 0 ? (
                          <TableRow><TableCell colSpan={3} align="center">Veri bulunamadı</TableCell></TableRow>
                        ) : (
                          absenteesEnriched.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.EmployeeID || '-'}</TableCell>
                              <TableCell>{row.fullName}</TableCell>
                              <TableCell>{row.department}</TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Paper>
          </Grid>
          {/* Devamsızlar (7 gün) Tablosu */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Card sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    Ziyaretçiler
                  </Typography>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>ID</TableCell>
                          <TableCell>Ziyaretçi Adı</TableCell>
                          <TableCell>Şirket</TableCell>
                          <TableCell>Neden</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {visitors.length === 0 ? (
                          <TableRow><TableCell colSpan={4} align="center">Veri bulunamadı</TableCell></TableRow>
                        ) : (
                          visitors.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.ID}</TableCell>
                              <TableCell>{row.VisitorName}</TableCell>
                              <TableCell>{row.Company}</TableCell>
                              <TableCell>{row.VisitReason}</TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Paper>
          </Grid>
          {/* Fazla Mesai Yapanlar Tablosu */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Card sx={{ minHeight: 200, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    Fazla Mesai Yapanlar
                  </Typography>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Personel ID</TableCell>
                          <TableCell>Ad Soyad</TableCell>
                          <TableCell>Giriş Saati</TableCell>
                          <TableCell>Çıkış Saati</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {overtimersEnriched.length === 0 ? (
                          <TableRow><TableCell colSpan={4} align="center">Veri bulunamadı</TableCell></TableRow>
                        ) : (
                          overtimersEnriched.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{row.EmployeeID || '-'}</TableCell>
                              <TableCell>{row.fullName}</TableCell>
                              <TableCell>{formatUTCDateTR(row.entryTime)}</TableCell>
                              <TableCell>{formatUTCDateTR(row.exitTime)}</TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Paper>
          </Grid>
        </Grid>



      <Dialog open={openJsonTableDialog} onClose={handleCloseJsonTableDialog} maxWidth="md" fullWidth>
        <DialogTitle>Detaylar</DialogTitle>
        <DialogContent>
          {Array.isArray(selectedJsonData) && selectedJsonData.length > 0 ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {Object.keys(selectedJsonData[0]).map((key) => (
                      <TableCell key={key}>{turkishColumnNames[key] || key}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedJsonData.map((row, idx) => (
                    <TableRow key={idx}>
                      {Object.keys(row).map((key) => (
                        <TableCell key={key}>
                          {(key === 'StartDate' || key === 'EndDate' || key === 'EntryTime' || key === 'ExitTime' || key === 'entryTime' || key === 'exitTime' || key === 'date' || key === 'hireDate')
                            ? formatLeaveDateTR(row[key])
                            : String(row[key])}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography>Veri yok</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseJsonTableDialog}>Kapat</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Dashboard;